import { HttpClient } from '../HttpClient';
/**
 * * Get Company Lookups
 */
export const GetCompanyLookups = async (PageNumber = 1, RowsPerPage = 100, SortOrder = 'asc', SortColumn = 'id') => {
  try {
    const { data } = await HttpClient.get('api/lookups/companies', {
      params: {
        PageNumber,
        RowsPerPage,
        SortOrder,
        SortColumn,
      },
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
